module.exports = __webpack_public_path__ + "img/PL.cf2ea70b.svg";